import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import {
  useBalanceTransferRolloverContext,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/BalanceSheetPicker/BalanceTransferRollover/Context';
import ResetButton from './ResetButton';

const ResetButtonPicker = () => {
  const { balanceTransferResource } = useBalanceTransferRolloverContext();

  const Component = pickWithPriority(balanceTransferResource, [
    [fr.relationships.reset.name, ResetButton],
  ], null);

  if (!Component) {
    return null;
  }

  return <Component />;
};

export default ResetButtonPicker;
